import { useIsDesktop } from "@/hooks/useIsDesktop"

/** Below Tailwind's `md` breakpoint (768px) — the app sidebar becomes a sheet. */
export const MOBILE_QUERY = "(max-width: 767px)"

export function useIsMobile(): boolean {
  // useIsDesktop is a generic matchMedia hook; only its default query is desktop-specific.
  return useIsDesktop(MOBILE_QUERY)
}
